/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetJobNotificationSettingsTeammateNotificationStatus interface.
 */
export function instanceOfGetJobNotificationSettingsTeammateNotificationStatus(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isSubscribed' in value) || value['isSubscribed'] === undefined)
        return false;
    return true;
}
export function GetJobNotificationSettingsTeammateNotificationStatusFromJSON(json) {
    return GetJobNotificationSettingsTeammateNotificationStatusFromJSONTyped(json, false);
}
export function GetJobNotificationSettingsTeammateNotificationStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'displayName': json['displayName'],
        'email': json['email'],
        'isSubscribed': json['isSubscribed'],
    };
}
export function GetJobNotificationSettingsTeammateNotificationStatusToJSON(json) {
    return GetJobNotificationSettingsTeammateNotificationStatusToJSONTyped(json, false);
}
export function GetJobNotificationSettingsTeammateNotificationStatusToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'displayName': value['displayName'],
        'email': value['email'],
        'isSubscribed': value['isSubscribed'],
    };
}
